export const ADD_UNIT = 'ADD_UNIT';

export const REPLACE_UNIT = 'REPLACE_UNIT';

export const REMOVE_UNIT = 'REMOVE_UNIT';

export const EDIT_UNIT_INFO = 'EDIT_UNIT_INFO';

export const EDIT_UNIT_FLOW = 'EDIT_UNIT_FLOW';

export const SET_UNIT_VALUE = 'SET_UNIT_VALUE';

export const EDIT_PORT = 'EDIT_PORT';

export const INSERT_ON_CONNECTION = 'INSERT_ON_CONNECTION';

export const EDIT_LAYOUT = 'EDIT_LAYOUT';

export const EDIT_LAYOUTS = 'EDIT_LAYOUTS';

export const EDIT_MULTIPLE_UNIT_LOCATIONS = 'EDIT_MULTIPLE_UNIT_LOCATIONS';

export const TOGGLE_MIRRORING = 'TOGGLE_MIRRORING';

export const HIGHLIGHT_NODES = 'HIGHLIGHT_NODES';

export const EDIT_FLOW_PROPERTIES = 'EDIT_FLOW_PROPERTIES';

export const ADD_STORAGE_TO_SCREEN_OUTPUTS = 'ADD_STORAGE_TO_SCREEN_OUTPUTS';
